export default {
    REFRESH_TOKEN: `refresh_token`,
    SIGN_IN: `login`,
    SIGN_UP: `registration`,
    FORGOT_PASSWORD: `forgot_password`,
    UPDATE_PROFILE: `user/update`,
    UPDATE_PHOTO: `user/update/photo`,
    RESET_PASSWORD: (token) => `reset_password/${token}`,
    CHANGE_PASSWORD: `update_password`,
    SEND_MESSAGE: (chatbotId) => `chatbot/chat/${chatbotId}`,
    SEND_MESSAGE_EMBED: (chatbotId, tokenId) => `widgetChat/${chatbotId}/${tokenId}`,
    USER_ROLES: (userId) => `roles/user/${userId}`,
    ROLES:`/roles`,
    USER_LIST: (page = 1, limit = 10) => `user/list?page=${page}&limit=${limit}`,
    CREATE_USER: '/admin/users',
    UPDATE_USER: (userId) => `/admin/users/${userId}`,
    DELETE_USER: (userId) => `/admin/users/${userId}`,
    // If you need to update user status separately
    UPDATE_USER_STATUS: (userId) => `/api/admin/users/${userId}/status`,
    // If you need to update user roles separately  
    UPDATE_USER_ROLES: (userId) => `/admin/users/${userId}/roles`,

    SEND_MESSAGE_ALPHA: (chatbotId) => `chatbot/chat/alpha/${chatbotId}`,
    SEND_SUPERVISOR_REPLY: (topicId) => `topics/${topicId}/supervisor-reply`,
    BOT_RESOURCE: `chatbot`,
    REQUEST_BOT: `bot_requests`,
    BOT_ADD: `chatbot/category/add`,
    BOT_DELETE: `chat/category/delete`,
    BOT_CALL: `chat/conversation/bot`,
    BOT_CONFIG: (chatbotId) => `chatbot/configs/${chatbotId}`,
    BOT_FILE_UPLOAD: (chatbotId) => `chatbots/${chatbotId}/upload`,
    BOT_FILE_DOWNLOAD: (fileId) => `chatbots/files/${fileId}/download`,
    BOT_FILES: (chatbotId) => `chatbots/${chatbotId}/files`,
    BOT_MY_ASSISTANTS: `chatbot/myassistants`,
    FILES_EMBED: (chatbotId) => `chatbots/${chatbotId}/embed`,
    TOOLS: (chatbotId) => `chatbots/${chatbotId}/tools`,
    TOPIC_LIST: (chatbotId, userId) => `topics/${chatbotId}/${userId}`,
    ALL_TOPICS: () => `topics/all`,
    TOPIC_RESOURCE: (topicId) => `topics/${topicId}`,
    TOPIC_CONVO: (topicId) => `topics/${topicId}/messages`,
    TOPIC_INFO: (topicId) => `topics/${topicId}`,
    DEL_CONVO: (chatbotID) => `topics/chatbot/${chatbotID}/playground/messages`,
    LLM_LIST: `llms`,
    ROADMAPS: `roadmaps`,
    SUPERVISOR: `supervisor-feedback/`,
    DOCTOR_LIST: `doctors/`,
    DOCTOR_CREATE: `doctors/create`,
    CHAMBER_LIST: `chambers/`,
    CHAMBER_CREATE: `chambers/create`,
    BULK_FILE_INPUT: `geo_location/seed_data`,

    GET_POST_ACCESS_KEY: 'access_keys',
    UPDATE_DELETE_ACCESS_KEY: (accessKey) => `access_keys/${accessKey}`,
    PERSONA_PROMPT: 'persona/prompt',
    DEFAULT_PROMPT: 'persona/user/prompts',

    SUPERVISOR_LIST: (page = 1, limit = 10) => `user/supervisor-list?page=${page}&limit=${limit}`,
    SUPERVISOR_ADD: `registration/human_supervisor`,
    SUPERVISOR_DELETE: (supervisorId) => `user/supervisor-list?user_id=${supervisorId}`,
    CHANGE_SUPERVISOR_MODE: (topicId) => `topics/${topicId}/handle-take-over`,

    CREATE_MEMBERSHIP_PLAN: `/membership_plans/`,
    UPDATE_MEMBERSHIP_PLAN: (id) => `/membership_plans/${id}`,
    DELETE_MEMBERSHIP_PLAN: (id) => `/membership_plans/${id}`,
    GET_MEMBERSHIP_PLANS: `/membership_plans/`,
    USER_MEMBERSHIP: (userId) => `/user-memberships/${userId}`,
    MEMBERSHIP_REQUESTS_RESOURCE: (userId) => `/user-memberships/upgrade-requests/${userId}`,
    ADMIN_UPGRADE_REQUESTS: `/user-memberships/upgrade-requests`,
    ADMIN_UPDATE_UPGRADE_REQUESTS: (requestId) => `/user-memberships/upgrade-requests/admin/${requestId}`
};